export enum headerEnum {
  MARKETING_HUB = 'System Voucher',
  SOCTRIP = "Soctrip",
  TMTRAVEL = 'TMTravel'
}
